import { PrinterPosStarOutlineIcon } from './PrinterPosStarOutlineIcon';

/**
 * author: Colton Wiscombe
 * id E7889DB0-6E76-4CA9-BD0B-92B7E8304381
 * name printer-pos-star-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-star-outline.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptStarOutlineIcon = PrinterPosStarOutlineIcon;
export default PrinterReceiptStarOutlineIcon